import { Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnagraficaService } from '../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'app-ana-lotti',
  templateUrl: './ana-lotti.component.html',
  styleUrls: ['./ana-lotti.component.css']
})
export class AnaLottiComponent extends NicaMaster implements OnInit {

  @Input() showTitle: boolean = true;
  @Output() rowSelected = new EventEmitter<any>();
  help: any;
  buttonCustom2: any[] = []
  moment = require('moment')
  constructor(private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }


  ngOnInit() {

    if (this.itemData) {
      this.currentTabId = this.itemData[0].componentName,
        this.currentTabName = this.itemData[0].componentName
      this.setGlobalVariableFromParams(this.itemData[0])



    } else {
      this.activateRoute.queryParams.subscribe(params => {
        this.params = params

        console.log("Parametri=", this.params);


        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName



        this.setGlobalVariableFromParams(params);

        console.log(this.template)
      })
    }
  }

  validateDataFieldPrepared(e: any) {
    console.log("In prepared ", e);
  }

  async formEvent(event) {
    console.log('stampo event', event)
    if (event.name == 'beforSave') {
      await this.checkValidationsForm(event)
    }

    if (event.name === "submittedInsertOk") {
      this.refreshPage([], '', this.SubjectCall, 'grid');
    }

    if (event.name == 'return') {
      this.refreshPage([], '', this.SubjectCall, 'grid');
      return;
    }
  }

  async checkValidationsForm(event): Promise<boolean> {
    const fail = (msg: string) => {
      alert(msg, 'Attenzione');
      event.cancella = true;
      event.cancel = true;
      return;
    };

    let form = event.formData
    let dataInizio = form['dataInizio'];
    let dataFine = form['dataFine'];
    let mStart = dataInizio ? this.moment(dataInizio).startOf('day') : null;
    let mEnd = dataFine ? this.moment(dataFine).startOf('day') : null;

    if (mEnd && mStart && mEnd.isBefore(mStart)) {
      fail('La data di fine non può essere precedente alla data di inizio');
      return false;
    }
    return true;
  }

}
